import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { cn } from "@utils/utils"

import { environment } from "@data/environment"
import Button from "@components/Button/Button"

export default function Environment({ lang, className = null }) {
  const data = useStaticQuery(graphql`
    query {
      file(
        sourceInstanceName: { eq: "images" }
        name: { eq: "Paris-Fulton-FEHR-Group" }
      ) {
        ...Constrained
      }
      leaf: file(
        name: { eq: "feuille" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      co2: file(
        name: { eq: "baisse_emissions_CO2" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
      earth: file(
        name: { eq: "main_planete_verte" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...Constrained
      }
    }
  `)
  return (
    <div className={cn(className, "overflow-hidden")}>
      <div className="mx-auto grid grid-cols-1 sm:gap-y-20 lg:grid-cols-3">
        <div className="col-span-2 flex h-full flex-col items-start justify-center gap-y-5 p-7 lg:p-20">
          <div className="grid max-w-xs grid-cols-3 gap-5">
            {["co2", "leaf", "earth"].map((it, idx) => (
              <GatsbyImage
                key={idx}
                image={getImage(data[it])}
                alt={data[it].name}
                objectFit="contain"
              />
            ))}
          </div>
          <div>
            <p className="text-base leading-7 text-fehr-500">
              {environment[lang].title}
            </p>
            <h2 className="mt-2 text-3xl font-bold sm:text-4xl">
              {environment[lang].headline}
            </h2>
            <p className="text-lg leading-8">{environment[lang].line1}</p>
          </div>
          <Button
            buttonString={environment[lang].link.title}
            buttonURL={environment[lang].link.url}
          />
          {/* <p className="text-lg leading-8">{environment[lang].line2}</p>
            <p className="text-sm leading-8">{environment[lang].asterix}</p> */}
          {/* <dl className="my-3 max-w-xl border-2 border-black p-3 leading-7 lg:inline-block lg:max-w-none">
            {environment[lang].carbonReduction.map((feature) => (
              <div key={feature.name}>
                <dt className="inline text-xl ">{feature.name} :</dt>{" "}
                <dd className="inline text-3xl font-bold">
                  {feature.reduction}
                </dd>
              </div>
            ))}
          </dl>
          {environment[lang].avantages.map((avantage: string, i: number) => (
            <p key={i} className="arrow-before">
              {avantage}
            </p>
          ))} */}
        </div>
        <div className="col-span-1 flex items-stretch lg:order-first">
          <GatsbyImage image={getImage(data.file)!} alt={data.file.name} />
        </div>
      </div>
    </div>
  )
}
